
<h1 mat-dialog-title>{{data.messageTitle}}</h1>
<div mat-dialog-content>
  <h2 mat-dialog-title>{{data.messageBody}}</h2>
</div>
<div mat-dialog-actions>

  @if (data.confirmCallback != null) {
    <button mat-button (click)="onNoClick()" class="cancel-button">Anuluj</button>
  }

  @if (data.confirmCallback != null) {
    <button mat-button (click)="onAck()" class="accept-button">Dalej</button>
  }
  @if (data.confirmCallback == null) {
    <button mat-button (click)="onAck()" class="b2c-next-step-button">Dalej</button>
  }
</div>
